import { createRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/modules/dashboard/DashboardPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/',
  component: DashboardPage,
});
